module.exports = __webpack_public_path__ + "img/ivica-mamic.062aa47d.jpg";